import { combineReducers } from 'redux';
import { data } from 'src/stores/reducers/data';

export const rootReducers = combineReducers({
  data
});
